interface ActivityCardProps {
  activity: any;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

const typeLabels: Record<string, string> = { webinar: 'וובינר', workshop: 'סדנה', training: 'הכשרה' };
const typeColors: Record<string, string> = { webinar: 'bg-violet-50 text-violet-600 border-violet-200', workshop: 'bg-amber-50 text-amber-600 border-amber-200', training: 'bg-emerald-50 text-emerald-600 border-emerald-200' };

export default function ActivityCard({ activity, onEdit, onDelete }: ActivityCardProps) {
  const typeName = activity.type?.name || 'webinar';
  const participantPct = activity.max_participants ? Math.round((activity.participants_count / activity.max_participants) * 100) : 0;

  return (
    <div className="bg-white rounded-2xl border-2 border-rose-100 overflow-hidden hover:border-rose-200 transition-all duration-200 hover:scale-[1.01]">
      <div className="relative w-full h-40 overflow-hidden">
        <img src={activity.image || ''} alt={activity.title} className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
        <span className={`absolute top-3 right-3 text-xs font-semibold px-2.5 py-1 rounded-full border-2 ${activity.status === 'active' ? 'bg-emerald-50 text-emerald-600 border-emerald-200' : 'bg-gray-100 text-gray-500 border-gray-200'}`}>
          {activity.status === 'active' ? 'פעיל' : 'הסתיים'}
        </span>
        <span className={`absolute top-3 left-3 text-xs font-semibold px-2.5 py-1 rounded-full border-2 ${typeColors[typeName]}`}>{typeLabels[typeName]}</span>
      </div>
      <div className="p-4">
        <h3 className="font-bold text-gray-800 text-sm mb-3 leading-snug">{activity.title}</h3>
        <div className="space-y-1.5 mb-4">
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-line"></i></div>
            <span>{activity.date} · {activity.time}</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line"></i></div>
            <span>{activity.location}</span>
          </div>
          
        </div>
        <div className="flex gap-2">
          <button onClick={() => onEdit(activity.id)} className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl border-2 border-rose-200 bg-rose-50 text-rose-500 text-xs font-semibold hover:bg-rose-100 transition-all cursor-pointer whitespace-nowrap">
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-edit-line"></i></div>עריכה
          </button>
          {!activity.is_protected && (
            <button onClick={() => onDelete(activity.id)} className="flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl border-2 border-gray-200 bg-gray-50 text-gray-400 text-xs font-semibold hover:bg-red-50 hover:border-red-200 hover:text-red-400 transition-all cursor-pointer whitespace-nowrap">
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-delete-bin-line"></i></div>
            </button>
          )}
          {activity.is_protected && (
            <div className="flex items-center justify-center px-3 py-2 rounded-xl border-2 border-amber-200 bg-amber-50 text-amber-500 text-xs font-semibold whitespace-nowrap">
              <i className="ri-lock-line ml-1"></i> מוגן
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
